module.exports = "<mat-card-title>{{ title }}</mat-card-title>\n<mat-card-content>\n  {{ firstMessage }}\n  <ng-container>\n    <img [src]= \"imgSrc\" />\n  </ng-container>\n</mat-card-content>\n<div class=\"centrarBotones\">\n    <button type=\"button\" mat-raised-button color=\"warn\"\n    (click)=\"dialogRef.close()\">{{cancelButtonTextLabel}}</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/modals/modal-image-dialog.component.html
// module id = ./src/app/shared-components/modals/modal-image-dialog.component.html
// module chunks = main